type IOptions = {
  name: string,
  value?: number,
  value_string?: string;
  color?: string,
}

//#region Date Related
export const  DateFormat : string = "DD-MMM-YYYY"
export const Months : string[] = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]; 
//#endregion Date Related

//#region Chart JS Related
export const FontFamily = "Poppins";
export const ChartJSBaseFontColor = "#32325d";

export const LineGraphType = {
  DAILY : 1,
  MONTHLY : 2
}
//#endregion Chart JS Related

//#region User Activity Logs Related
export const UserActivityGroupType = {
  OPEN : 1,
  NUDGE : 2,
  WC : 3,
  MIC : 4,
  MC : 5,
  EM : 6,
  CA : 7,
}

export const UserActivityType = {
  OPEN : 1,
  NUDGE_ACKNOWLEDGE : 2,
  NUDGE_SNOOZE : 3,
  NUDGE_DEEPWORK : 4,
  WC : 5,
  MIC : 6,
  MC : 7,
  EM_CREATE : 8,
  EM_DELETE : 9,
  EM_ACKNOWLEDGE : 10,
  EM_DEEPWORK : 11,
  CA : 12
}

export const UserActivityTypeWithGroup = {
  OPEN : {
    id : 1,
    group : UserActivityGroupType.OPEN
  },
  NUDGE_ACKNOWLEDGE : {
    id : 2,
    group : UserActivityGroupType.NUDGE
  },
  NUDGE_SNOOZE : {
    id : 3,
    group : UserActivityGroupType.NUDGE
  },
  NUDGE_DEEPWORK : {
    id : 4,
    group : UserActivityGroupType.NUDGE
  },
  WC : {
    id : 5,
    group : UserActivityGroupType.WC
  },
  MIC : {
    id : 6,
    group : UserActivityGroupType.MIC
  },
  MC : {
    id : 7,
    group : UserActivityGroupType.MC
  },
  EM_CREATE : {
    id : 8,
    group : UserActivityGroupType.EM
  },
  EM_DELETE : {
    id : 9,
    group : UserActivityGroupType.EM
  },
  EM_ACKNOWLEDGE : {
    id : 10,
    group : UserActivityGroupType.EM
  },
  EM_DEEPWORK : {
    id : 11,
    group : UserActivityGroupType.EM
  },
  CA : {
    id : 11,
    group : UserActivityGroupType.EM
  },
}


interface UserActivityGroupTypeInterface {
  id : number;
  name : string;
}

export const UserActivityGroup : UserActivityGroupTypeInterface[] = [
  {
    id : UserActivityGroupType.OPEN,
    name : `Log In`,
  },
  {
    id : UserActivityGroupType.NUDGE,
    name : `Nudge`
  },
  // {
  //   id : UserActivityGroupType.WC,
  //   name : `Workhealth.Coach`
  // },
  {
    id : UserActivityGroupType.MIC,
    name : `MyIntention.Coach`
  },
  {
    id : UserActivityGroupType.MC,
    name : `Movement.Coach`
  },
  {
    id : UserActivityGroupType.EM,
    name : `Empower ME`
  },
  {
    id : UserActivityGroupType.CA,
    name : `Challenge Acknowledgement`
  },
  
]

interface UserActivityTypeInterface {
  id : number;
  name : string;
  group : number
}

export const UserActivity : UserActivityTypeInterface[] = [
  {
    id : UserActivityType.OPEN,
    name : `Log In`,
    group : UserActivityGroupType.OPEN
  },
  {
    id : UserActivityType.NUDGE_ACKNOWLEDGE,
    name : `Nudge Acknowledge`,
    group : UserActivityGroupType.NUDGE
  },
  {
    id : UserActivityType.NUDGE_SNOOZE,
    name : `Nudge Snooze`,
    group : UserActivityGroupType.NUDGE
  },
  {
    id : UserActivityType.NUDGE_DEEPWORK,
    name : `Nudge Deep Work`,
    group : UserActivityGroupType.NUDGE
  },
  {
    id : UserActivityType.WC,
    name : `Workhealth Coach`,
    group : UserActivityGroupType.WC
  },
  {
    id : UserActivityType.MIC,
    name : `MyIntention Coach`,
    group : UserActivityGroupType.MIC
  },
  {
    id : UserActivityType.MC,
    name : `Movement Coach`,
    group : UserActivityGroupType.MC
  },
  {
    id : UserActivityType.EM_CREATE,
    name : `Empower ME Create`,
    group : UserActivityGroupType.EM
  },
  {
    id : UserActivityType.EM_DELETE,
    name : `Empower ME Delete`,
    group : UserActivityGroupType.EM
  },
  {
    id : UserActivityType.EM_ACKNOWLEDGE,
    name : `Empower ME Acknowledge`,
    group : UserActivityGroupType.EM
  },
  {
    id : UserActivityType.EM_DEEPWORK,
    name : `Empower ME Deep Work`,
    group : UserActivityGroupType.EM
  },
  {
    id : UserActivityType.CA,
    name : `Challenge Acknowledgement`,
    group : UserActivityGroupType.CA
  }
];

export const ActivityHistoryTableDataTypeValue : string[] = [
  `User opened the app.`,
  `User clicked "Got It" for an nudge.`,
  `User clicked "Snooze" for an nudge.`,
  `User clicked "Deep Work" for an nudge.`,
  `User watched a video in Workhealth Coach.`,
  `User watched a video in MyIntention Coach.`,
  `User watched a video in Movement Coach.`,
  `User created a task in Empower ME.`,
  `User deleted a task in Empower ME.`,
  `User clicked "Got It" for an Empower ME nudge.`,
  `User clicked "Deep Work" for an Empower ME nudge.`,
  `User clicked "Acknowledge" for an Challenge.`,
  `User clicked "My Dashboard" for a nudge.`,
  `User clicked "My EAP" for a nudge.`,
  `User clicked "My Dashboard" for an Empower ME nudge.`,
  `User clicked "My EAP" for an Empower ME nudge.`,
];

//#endregion User Activity Logs Related

//#region User Activity Monitor Related

export const UserStatusTypes = {
  ACTIVE : 1,
  LOW_ACTIVITY : 2,
  INACTIVE : 3
}

interface Status {
  id : number,
  name : string;
  icon : string;
  color : string;
}

export const UserStatusTypesArray : Status[] = [
  {
    id : UserStatusTypes.ACTIVE,
    name : "Active",
    icon : "far fa-smile",
    color : "success"
  },
  {
    id : UserStatusTypes.LOW_ACTIVITY,
    name : "Low Activity",
    icon : "far fa-meh",
    color : "warning"
  },
  {
    id : UserStatusTypes.INACTIVE,
    name : "Inactive",
    icon : "far fa-frown",
    color : "danger",
  }
]

export const UserQuestionnaireType = {
  NOT_IN_USE : 1,
  ONBOARDING : 2,
  SCHEDULED : 3
}

export interface IUserQuestionnaireType {
  value : number;
  label : string;
  have_dates : boolean
}

export const UserQuestionnaireTypeObj : IUserQuestionnaireType[] = [
 {
  value : UserQuestionnaireType.NOT_IN_USE,
  label : "Not In use",
  have_dates : false
 },
 {
  value : UserQuestionnaireType.ONBOARDING,
  label : "Onboarding Questionnaire",
  have_dates : false
 },
 {
  value : UserQuestionnaireType.SCHEDULED,
  label : "Scheduled",
  have_dates : true
 }
]

//#endregion User Activity Monitor Related

//#region Onboarding
export const LocalStorageOnBoardingDateName = "onboarding_dismissed_date"; 
export const LocalStorageScheduledDateName = "scheduled_dismissed_date"; 
export const LocalStorageCoBrandingLogo = "last_cobranding_logo"; 
export const UserOnboardingVideoTypes = {
  NUDGE : 1,
  EMPOWER_ME : 2,
  IOS_TUITORIAL: 3,
  ANDROID_TUITORIAL: 4
}

export const UserOnboardingVideoTypesNames = [
  "desk.coach",
  "empower me",
  "IOS Tuitorial",
  "Android Tuitorial"
]

//#endregion Onboarding

//#region Empower.me
export const CATEGORY_PHYSICAL = "As a physically proactive person";
export const CATEGORY_NUTRITIONAL = "As a nutritionally aware person";
export const CATEGORY_PSYCHOLOGICAL = "As a psychologically proactive person";
export const CATEGORY_MINDFUL = "As a mindful individual";

export const EmpowerMeCategory : Array<string> = [
  CATEGORY_PHYSICAL, CATEGORY_NUTRITIONAL, CATEGORY_PSYCHOLOGICAL, CATEGORY_MINDFUL
]

export const CategoryTypes = {
  DEFAULT : 1,
  EMPOWER_ME : 2
}
//#endregion Empower.me

//#region User Properties
export const UserTypes = {
  MEMBER: 'member',
  ORGANISATION_ADMIN: 'organisation_admin'
}
export const UserTypeOptions: IOptions[] = [
  {
    name: 'Member',
    value_string: 'member',
  },
  {
    name: 'Organisation Admin',
    value_string: 'organisation_admin',
  }
]
export const UserLicensesType = ["desk.coach", "empower.me"]
//#endregion User

export interface SelectOption {
  label: string,
  value: string;
}

export interface Breadcrumb {
  name: string;
  path: string;
}

//#region Company Policy
export const COMPANY_POLICY_UNCATEGORIZED_TAG = 'Uncategorized';
export const ValidFileFormatForPolicy = '.pdf, .docx, .txt';
export const CompanyPolicyStatus = {
  ACTIVE: 1,
  ARCHIVED: 2,
}

export const CompanyPolicyStatusOptions: IOptions[] = [
  {
    name: 'ACTIVE',
    value: CompanyPolicyStatus.ACTIVE,
    color: 'success'
  },
  {
    name: 'ARCHIVED',
    value: CompanyPolicyStatus.ARCHIVED,
    color: 'light'
  },
]
export const CompanyPolicyNudgeStatus = {
  INREVIEW: 1,
  APPROVED: 2,
  REJECTED: 3,
  ARCHIVED: 4
}
export const CompanyPolicyNudgeStatusOptions: IOptions[] = [
  {
    name: 'IN REVIEW',
    value: CompanyPolicyNudgeStatus.INREVIEW,
    color: 'primary'
  },
  {
    name: 'APPROVED',
    value: CompanyPolicyNudgeStatus.APPROVED,
    color: 'success'
  },
  {
    name: 'REJECTED',
    value: CompanyPolicyNudgeStatus.REJECTED,
    color: 'danger'
  },
  {
    name: 'ARCHIVED',
    value: CompanyPolicyNudgeStatus.ARCHIVED,
    color: 'info'
  },
];

export const CompanyPolicyNudgeHistoryActions = {
  ADD: 1,
  UPDATE: 2,
  DELETE_OR_REJECT: 3,
  GENERATE: 4,
  REGENERATE: 5,
  APPROVE: 6,
  INREVIEW: 7,
}

export const CompanyPolicyNudgeHistoryActionOptions: IOptions[] = [
  {
    name: 'ADDED',
    value: CompanyPolicyNudgeHistoryActions.ADD,
    color: 'success'
  },
  {
    name: 'UPDATED',
    value: CompanyPolicyNudgeHistoryActions.UPDATE,
    color: 'primary'
  },
  {
    name: 'DELETED',
    value: CompanyPolicyNudgeHistoryActions.DELETE_OR_REJECT,
    color: 'danger'
  },
  {
    name: 'GENERATED',
    value: CompanyPolicyNudgeHistoryActions.GENERATE,
    color: 'purple'
  },
  {
    name: 'REGENERATED',
    value: CompanyPolicyNudgeHistoryActions.REGENERATE,
    color: 'purple'
  },
  {
    name: 'APPROVED',
    value: CompanyPolicyNudgeHistoryActions.APPROVE,
    color: 'success'
  },
  {
    name: 'MOVED TO REVIEW',
    value: CompanyPolicyNudgeHistoryActions.INREVIEW,
    color: 'primary'
  },
];

export const MAX_COMPANY_POLICY_NUDGES = 5;
export const MAX_TIMING_PER_DAY = 2;
export const COMPANY_NUDGE_SCHEDULE_DAYS = ["Monday", "Tuesday","Wednesday", "Thursday", "Friday"];
export const CompanySchedulesFilterStatus = {
  UPCOMING: 1,
  ALL: 2
}
export  const CompanySchedulesFilterStatusOptions: SelectOption[] = [
  { label: 'Show Upcoming', value: CompanySchedulesFilterStatus.UPCOMING.toString() },
  { label: 'Show All', value: CompanySchedulesFilterStatus.ALL.toString() }
]
//#endregion Company Policy

// #region Multi Library

export const LibraryCategoryStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
}
export const LibraryCategoryStatusOptions: IOptions[] = [
  {
    name: 'ACTIVE',
    value: LibraryCategoryStatus.ACTIVE,
    color: 'success'
  },
  {
    name: 'INACTIVE',
    value: LibraryCategoryStatus.INACTIVE,
    color: 'light'
  },
]
export const LibraryVideoStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
}
export const LibraryVideoStatusOptions: IOptions[] = [
  {
    name: 'ACTIVE',
    value: LibraryVideoStatus.ACTIVE,
    color: 'success'
  },
  {
    name: 'INACTIVE',
    value: LibraryVideoStatus.INACTIVE,
    color: 'light'
  },
]
// #endregion Multi Library